import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';
import { OutlinedButton } from '@prisjakt/ui/button/variants';
import { Tooltip as TooltipComponent } from 'src/components/tooltip-new';

const sharedCompareButtonStyled = css`
  align-items: center;
  align-self: stretch;
  outline: none;
  cursor: pointer;
  position: relative;
`;

const Tooltip = styled(TooltipComponent)``;

type CompareProductButtonProps = { $selected?: boolean };
const CompareProductButtonMobile = styled(OutlinedButton).attrs({
  'data-test': 'CompareProductButtonMobile',
})<CompareProductButtonProps>`
  display: flex;
  width: 100%;
  background-color: transparent;
  ${sharedCompareButtonStyled};

  ${props =>
    props.$selected &&
    css`
      background-color: ${props.theme.bg.productCompare};
      box-shadow: 0 0 0 1px ${props.theme.bg.productCompare};
      color: ${props.theme.text.primary};

      &:active,
      &:hover,
      &:focus {
        background-color: ${props.theme.bg.productCompare};
        box-shadow: 0 0 0 1px ${props.theme.bg.productCompare};
        color: ${props.theme.text.primary};
      }
    `};

  & > span {
    flex-grow: 0;
  }
`;

const CompareProductButtonDesktop = styled.button.attrs({
  'data-test': 'CompareProductButtonDesktop',
})`
  display: flex;
  padding: 0 ${layout.measurements.spacing025};
  ${sharedCompareButtonStyled};
`;

const Title = styled.span`
  display: none;

  ${media.mediumDown`
    display: block;
  `}
`;

type CompareIconWrapperProps = { active?: boolean };
export const CompareIconWrapper = styled.div<CompareIconWrapperProps>`
  background-color: ${({ theme, active }) =>
    active ? theme.bg.productCompare : 'transparent'};
  border-radius: ${layout.borderRadius};
  color: ${({ theme, active }) =>
    active ? theme.colors.base700 : theme.icons.callToAction};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;

  :hover {
    color: ${({ theme, active }) =>
      active ? theme.colors.base700 : theme.icons.callToActionHover};
  }
`;

export {
  CompareProductButtonDesktop,
  CompareProductButtonMobile,
  Title,
  Tooltip,
};
